
const urlBack = 'https://alice-accounting-essca.eu/Request.php'


const  BackendAPI = {
    login: async(dataConnexion)=>{
        console.log(dataConnexion) 
        
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                type: "loginAdmin",
                data:  dataConnexion
            }),
            isConnected:false
        };
   
        try {
            const response = await fetch(urlBack, requestOptions);
            console.log(response)
            // Vérifiez si la réponse est OK avant d'essayer de lire le JSON
            if (!response.ok) {
                throw new Error(`Erreur HTTP : ${response.status}`);
            }
            // Analyser la réponse en JSON
            const data = await response.json();
            return data;
        } catch (error) {
            console.error("Erreur lors de la connexion :", error);
            return null;
        }
    },

    getEtudiants:async()=>{
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                type:"getEtudiantsAccounting",
                data:{}
            }),
            /* mode:"no-cors", */
            isConnected:false
        };
        const response = await  fetch(urlBack, requestOptions)
        
        const data = await response.json()
        return  data
    },
    updateEtudiant:async(value,field,id)=>{
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                type:"updateEtudiantAccounting",
                data:{
                    value:value,
                    field:field,
                    id:id
                }
            }),
            /* mode:'no-cors', */
            isConnected:false
        };
        const response = await  fetch(urlBack, requestOptions)
        
        return response
    },
    createUser:async(user)=>{
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                type:"createEtudiantAccounting",
                data:{user:user}
            }),
            isConnected:false
        };

        const response = await  fetch(urlBack, requestOptions)
        return response
    },

    getQuestions:async(numJeu)=>{
        const formattedNumber = (parseInt(numJeu.split(" - ")[0], 10) + 10).toString().padStart(2, '0')
        const nomJeu = `questionsjeu${formattedNumber}`;
        console.log("TEST TEST "+nomJeu)
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            /* mode:"no-cors", */
            body: JSON.stringify({
                type:"getQuestions",
                data:{
                    nomJeu:nomJeu
                }
                
            }),
            isConnected:false
        };

        const response = await  fetch(urlBack, requestOptions)

        
        const data = await response.json()
        return  data

    },
    updateQuestion:async(value,field,id,numJeu)=>{

        const formattedNumber = (parseInt(numJeu.split(" - ")[0], 10) + 10).toString().padStart(2, '0')
        const nomJeu = `questionsjeu${formattedNumber}`;

        console.log(nomJeu+" "+field+" "+value+" "+id)

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                type:"updateQuestion",
                data:{
                    value:value,
                    field:field,
                    id:id,
                    nomJeu:nomJeu
                }
                
            }),
           /*  mode:'no-cors', */
            isConnected:false
        };
        const response = await  fetch(urlBack, requestOptions)
        const data = await response.json()
        return data
    },
    createQuestion:async(question,numJeu)=>{
        const formattedNumber = (parseInt(numJeu.split(" - ")[0], 10) + 10).toString().padStart(2, '0')
        const nomJeu = `questionsjeu${formattedNumber}`;

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                type:"createQuestionAccounting",
                data:{
                    question:question,
                    nomJeu:nomJeu
                }
                
            }),
            /* mode:'no-cors', */
            isConnected:false
        };

        const response = await  fetch(urlBack, requestOptions)

        return  await response.json()
    },

    getClassements:async()=>{
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                type:"getClassementAccounting",
                data:{
                    idUser:-1
                }
                
            }),
            /* mode:'no-cors', */
            isConnected:false
        };

        const response = await  fetch(urlBack, requestOptions)

        return  await response.json()
    },
};
export default BackendAPI